import React from "react";
import { number } from "prop-types";

const DefaultMobileLogo = ({ width = 165, height = 38 }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 230 54"
    enableBackground="new 0 0 230 54"
    width={width}
    height={height}
  >
    <g>
      <g>
        <path
          fill="#EE4023"
          d="M115,38.229c7.739,0,14.007-6.272,14.007-14.001c0-7.736-6.268-14.008-14.007-14.008
			c-7.727,0-14.002,6.272-14.002,14.008C100.998,31.958,107.273,38.229,115,38.229z"
        ></path>
        <g>
          <rect
            x="114.289"
            y="1.389"
            transform="matrix(1 -0.0011 0.0011 1 -0.0055 0.1311)"
            fill="#EE4023"
            width="1.426"
            height="6.968"
          ></rect>
        </g>
        <g>
          <rect
            x="121.2"
            y="6.709"
            transform="matrix(0.4855 -0.8742 0.8742 0.4855 57.6708 112.8397)"
            fill="#EE4023"
            width="7.012"
            height="1.426"
          ></rect>
        </g>
        <g>
          <rect
            x="127.984"
            y="13.729"
            transform="matrix(0.8515 -0.5243 0.5243 0.8515 11.9473 71.075)"
            fill="#EE4023"
            width="6.967"
            height="1.427"
          ></rect>
        </g>
        <g>
          <rect
            x="104.791"
            y="3.865"
            transform="matrix(0.873 -0.4878 0.4878 0.873 9.8232 52.3958)"
            fill="#EE4023"
            width="1.427"
            height="6.947"
          ></rect>
        </g>
        <g>
          <rect
            x="98.023"
            y="10.859"
            transform="matrix(0.5116 -0.8592 0.8592 0.5116 35.9213 91.83)"
            fill="#EE4023"
            width="1.426"
            height="6.919"
          ></rect>
        </g>
      </g>
      <g>
        <path
          fill="#231F20"
          d="M56.918,27.662c-11.35,7.327-15.6,9.417-15.6,9.417v7.193
			c14.54-6.89,23.456,1.897,23.456,1.897v2.464h6.809c0,0,0-18.233,0-20.894c0-2.664-2.21-3.627-2.21-3.627h12.203
			c0,0-3.703,1.065-5.295,2.136c-1.864,1.25-1.473,3.285-1.473,3.285l8.322,3.457c0,0,1.017,0.298,1.054,1.034
			c0.061,0.872-1.059,1.143-1.059,1.143s-4.794,0.372-7.188,2.335c-1.725,1.421-1.324,2.649-1.324,2.649v3.574
			c0.001,0.303,0.001,0.551,0.159,0.705c1.9,1.967,5.529,2.568,5.529,2.568l2.938-1.603c-3.099-0.237-3.234-0.947-3.28-1.549
			c-0.024-0.483,0.48-2.035,6.972-2.368c5.812-0.295,11.528,3.873,11.528,3.873v3.26h6.798c0,0,0-19.793,0-20.728
			c0-1.198-0.331-6.01-6.421-6.01l-5.929-0.041H60.435v0.95c4.42,0.447,4.334,3.445,4.334,3.445v14.608
			c-4.81-4.194-11.117-4.445-11.117-4.445c3.401-1.861,5.872-4.002,7.214-5.127c0.449-0.383,1.074-1.36,0.382-2.84
			c-1.068-2.285-2.314-4.037-4.282-5.793c-2.895-2.584-6.623-0.903-6.623-0.903l-3.615,1.631
			c-9.278-5.202-14.788-0.371-14.788-0.371v1.068c-14.351-9.559-24.037,2.573-24.037,2.573v3.105l9.754-0.025l-4.01,3.825v5.376
			l18.037-6.712v9.2c0,0-3.832-2.621-8.806-1.519c-3.062,0.678-7.732,2.481-9.053,2.54c-6.009,0.268-6.406-3.971-6.477-6.131
			c-0.051-1.538,1.708-1.309,1.708-1.309v-2.648H1.225c0,0-0.4,2.472-0.134,4.664c0.668,6.49,4.388,9.046,7.603,9.75
			c6.203,1.358,10.457-2.508,14.584-2.871c4.984-0.448,8.37,3.024,8.37,3.024v1.531h6.807V25.712
			c0.387-1.153,1.396-1.619,1.768-1.682c2.943-0.536,4.162,0.242,4.162,0.242s-0.878,0.452-2.122,1.378
			c-1.207,0.873-0.759,2.693-0.671,4.157c0.093,1.468,2.662,2.499,2.662,2.499l2.186-1.07c-1.997-0.66-0.799-1.91-0.799-1.91
			s7.713-3.596,9.044-4.173c0,0,0.225-0.112,0.712-0.278c0.487-0.166,1.057-0.093,1.368,0.559
			C57.075,26.088,57.548,27.256,56.918,27.662z M21.886,30.808c0,0-0.513,0.322-0.789,0.019c-0.132-0.13-0.048-0.374,0.252-0.662
			l1.561-1.434c0,0,1.369-1.279-0.539-1.373c-1.919-0.087-4.806-0.08-4.806-0.08S16.663,27.39,16.6,26.98
			c-0.039-0.194-0.035-0.433,0.296-0.64c0.761-0.495,12.201-3.111,15.362,0.751L21.886,30.808z M94.657,34.148
			c0,0,0.53-1.931-3.247-3.571c-0.499-0.219-3.845-1.754-7.115-3.094c-0.535-0.211-0.809-1.198,0.172-1.552
			c0.98-0.354,6.199-1.818,6.199-1.818h4.553c0,0,3.223,0.015,3.223,3.167l0.014,12.611c0,0-2.5-2.55-7.762-4.1L94.657,34.148z"
        ></path>
      </g>
      <g>
        <path
          fill="#231F20"
          d="M223.37,21.746h-51.188h-49.742v2.578l7.129-0.003
			c-7.671,2.341-6.881,6.168-6.881,6.168v6.71c0.186,3.355,4.032,2.979,4.032,2.979s3.935-0.629,6.197-1.553
			c2.751-0.863,4.036-1.757,4.036-1.757c2.915-1.348,1.864-3.705,1.783-3.921c-0.635-1.562-3.072-3.583-3.072-3.583l-2.771,0.865
			l0.608,0.6c1.026,0.75-0.872,1.776-0.872,1.776l-4.425,1.4c-2.286,0.541-1.513-1.102-1.398-1.326
			c0.624-1.406,3.381-2.733,4.341-3.234c7.026-3.718,8.754-0.651,9.56,0.216c5.291,5.651,0.223,10.055-0.883,11.04
			c-3.31,2.971-8.051,5.706-14.268,5.778c-6.894,0.08-8.495-3.244-8.495-3.244l0.641-1.533l-2.478-1.277l-5.679,6.762
			c21.056,14.366,36.018-4.332,36.018-4.332c3.317,1.126,5.176,3.395,5.176,3.395v2.186h6.62V27.867
			c-0.047-3.044-2.062-3.545-2.062-3.545h4.487c2.377,0.875,2.101,3.582,2.101,3.582v20.531h6.877V27.602
			c-0.028-2.964-2.19-3.281-2.19-3.281h5.314h9.646c-1.265,0.839-2.58,1.847-5.857,4.32c-3.269,2.754-2.748,5.919-2.748,5.919v6.52
			c-0.087,1.184,1.103,2.725,1.679,3.176c4.382,3.446,8.004,4.799,9.768,5.317c5.122,1.503,7.748-1.527,7.748-1.527l2.365-2.545
			l-2.432-1.315c-1.735,2.749-6.09-0.212-6.09-0.212s-2.733-1.617-3.901-2.32c-3.38-2.159-3.314-3.115-3.314-3.115l0.031-7.447
			c0.314-2.243,8.018-6.773,8.018-6.773h22.275c2.608,0.858,2.327,3.737,2.327,3.737v4.454c-3.281-2.534-5.792-1.023-5.792-1.023
			l-4.115,2.053c0,0,1.039-1.478,2.292-3.243c1.174-1.67-0.457-2.198-3.99-3.827c-4.557-2.102-7.387,0.098-7.387,0.098
			s-2.828,1.512-5.767,3.664c-2.937,2.158-2.679,4.252-2.679,4.252v3.241c1.631,2.757,5.461,1.914,5.461,1.914l0.938-1.854
			c-2.405-0.143-1.949-1.221-1.611-1.631c0,0,9.205-5.615,10.891-6.492c0.25-0.13,0.817,0.076,0.592,0.564
			c-0.873,1.893-4.673,6.378-4.932,7.025c-1.592,4.095,1.171,5.187,1.171,5.187l11.33-5.597c2.941-1.409,3.597,0.728,3.597,0.728
			v11.15h6.606V28.058c0.031-2.923-2.311-3.737-2.311-3.737h4.447c2.604,1.084,2.358,3.752,2.358,3.752v20.649H229
			c0,0,0-18.124,0-20.668C229,25.51,227.731,21.746,223.37,21.746z M150.74,40.268c0,0-1.185-1.78-3.16-2.803
			c0,0,0.955-9.371-9.161-13.144h10.294c0,0,1.995,0.502,2.027,3.567V40.268z"
        ></path>
      </g>
    </g>
  </svg>
);

DefaultMobileLogo.propTypes = {
  width: number,
  height: number
};

export default DefaultMobileLogo;
